import {UserRole} from "@/constants.ts";
import {useJwtAuth, useJwtUser} from "@/JWTAuthProvider.tsx";
import {createFileRoute, Navigate, redirect, useNavigate} from '@tanstack/react-router'
import React from "react";
import {profileLanding} from "@/onboarding/plays.ts";
import {useSports} from "@/sports/registry.ts";

export const Route = createFileRoute('/_app/profiles/me')({
    component: RouteComponent,
})

function RouteComponent() {
    const jwt = useJwtAuth();
    const user = useJwtUser();
    const {data: registry} = useSports();

    if (!jwt.initialized) {
        return <></>
    }
    if (!user) {
        return <Navigate to={'/login/'} />
    }

    if (user?.role === UserRole.Master) {
        return <Navigate to={`/ai/`} replace={true} />
    }
    if (user?.community?.uid) {
        return <Navigate to={`/communities/${user.community.uid}/` as any} replace={true} />
    }
    if (user?.club?.uid) {
        return <Navigate to={`/clubs/${user.club.uid}/` as any} replace={true} />
    }
    // Their profile, on the sport they played last (Football for a football player).
    return <Navigate {...(profileLanding(user as any, registry) as any)} replace={true} />
}
